import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import LeadButton from '@/components/LeadButton';
import Title from '@/components/Title';

const Index = () => {
  const { t, i18n } = useTranslation('whyWukong');
  return (
    <section className="container mt-20 lg:mt-[140px] xl:mt-[180px]">
      <Title className="" innerHTML theme="colorful">
        {t('理由-国际竞争力-标题')}
      </Title>
      <div className="lg:m6-12 mb-3  mt-8 flex justify-center xl:my-15">
        <video
          className="video1  block h-full  w-[335px] rounded-xl  object-cover  lg:w-[850px] lg:rounded-[27px]  xl:w-[1114px] xl:rounded-5xl"
          src={`https://cdnwukong.com/images/growth/video/${i18n.language === 'en' ? 'why-wukong-internation-en-new.mp4' : 'why-wukong-internation-zh-240903.mp4'}`}
          controlsList="nodownload, nofullscreen"
          playsInline
          x5-video-player-fullscreen="false"
          x5-playsinline="true"
          webkit-playsinline="true"
          loop
          autoPlay
          muted
        />
      </div>
      <div className="flex justify-center">
        <div className="flex w-[335px] flex-col items-center gap-[12px] lg:w-[850px] lg:flex-row  lg:gap-[16px] xl:w-[1114px] xl:gap-[21px]">
          <div className="relative w-full lg:h-[241px] lg:basis-[347px] xl:h-[343px] xl:basis-[452px]">
            {/* 使用Image图片会很模糊 */}
            <Image
              src="/images/reasonsForChoosing/internationalCompetitiveness/begin.png"
              alt="begin"
              width={423}
              height={343}
              className="h-full w-full rounded-[24px]"
              width={335}
              height={241}
              loading="lazy"
            />
            <div className="absolute left-0 top-0 h-[100%] w-[100%] rounded-[24px] [background:linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(0,0,0,0.52)_62.67%)]" />
            <p
              className="[&_>span]:before:contents-[''] absolute bottom-0 right-0 w-full px-3 py-5 text-sm leading-5 text-white lg:w-[339px] xl:w-[410px] xl:text-[20px] xl:leading-7 [&_>span]:relative [&_>span]:z-10 [&_>span]:inline-block [&_>span]:before:absolute [&_>span]:before:bottom-[2px] [&_>span]:before:left-0 [&_>span]:before:-z-10 [&_>span]:before:w-full [&_>span]:before:border-b-4 [&_>span]:before:border-wk-red-500 [&_>span]:lg:before:bottom-0 [&_>span]:lg:before:border-b-[6px] [&_>span]:xl:before:border-b-8"
              dangerouslySetInnerHTML={{ __html: t('理由-国际竞争力-开始') }}
            />
          </div>
          <div className="w-full lg:basis-[235px] xl:basis-[356px]">
            <Image
              src="/images/reasonsForChoosing/internationalCompetitiveness/party.png"
              alt="end"
              className="h-auto rounded-3xl xl:h-[339px]"
              width={335}
              height={241}
              loading="lazy"
            />
          </div>
          <div className="space-y-[12px] text-base leading-6 lg:basis-[235px] lg:text-sm lg:leading-5 lg:leading-[22px] xl:basis-[335px] xl:text-[20px] xl:leading-7">
            <p
              className="mt-3 [&_>span]:font-black"
              dangerouslySetInnerHTML={{ __html: t('理由-国际竞争力-30万家庭') }}
            />
            <p className="[&_>span]:font-black" dangerouslySetInnerHTML={{ __html: t('理由-国际竞争力-12个国家') }} />
          </div>
        </div>
      </div>
      <div className="mt-6 text-center lg:mt-12 xl:mt-15">
        <LeadButton
          theme="colorfulBorder"
          size="xl"
          traceName="O_WhyWuKong_FromOverseas_CTAClick"
          traceGa4Name="new_entry_How_FromOverseasCTA"
        >
          {t('理由-立即体验')}
        </LeadButton>
      </div>
    </section>
  );
};

export default Index;
